var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":14}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
      'captcha',
      { rules: [{ required: true, message: '请输入图形验证码' }] },
    ]),expression:"[\n      'captcha',\n      { rules: [{ required: true, message: '请输入图形验证码' }] },\n    ]"}],attrs:{"size":"large","placeholder":"图形验证码"}})],1),_c('a-col',{attrs:{"span":10}},[_c('img',{attrs:{"width":"80px","height":"40px","src":require("@/assets/logo.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }